import Vue from 'vue';
import store from '../store';
import Router from 'vue-router';
import Login from '@/pages/Login';
import ForgetPassword from '@/pages/ForgetPassword';
import ResetPassword from '@/pages/ResetPassword';
import PasswordResetStep from '@/pages/PasswordResetStep';
import Signup from '@/pages/Signup';
import Verification from '@/pages/Verification';
import MyRequest from '@/pages/MyRequest';
import IMRequest from '@/pages/IMRequest';
import IMExport from '@/pages/IMExport';
import IMApproval from '@/pages/IMApproval';
import NewForm from '@/pages/NewForm';   
import IMPayment from '@/pages/IMPayment';   
import IMAnouncement from '@/pages/IMAnouncement';   
import EditForm from '@/pages/EditForm';
import EditFormPayment from '@/pages/EditFormPayment';
import EditFormAnouncement from '@/pages/EditFormAnouncement';
import Approval from '@/pages/Approval';
import QrScan from '@/pages/QrScan';
import CMSBank from '@/components/CMSBank';
import ViewApproval from '@/pages/ViewApproval';
import RegWaNumber from '@/pages/RegWaNumber';
import RegWaNumberWithoutLogin from '@/pages/RegWaNumberWithoutLogin';
import MyProfile from '@/pages/MyProfile';
import Users from '@/pages/Users';
import UsersFormCreate from '@/pages/UsersFormCreate';
import UsersFormEdit from '@/pages/UsersFormEdit';
import UsersBisnisUnit from '@/pages/UsersBisnisUnit';
import UsersBisnisUnitCreate from '@/pages/UsersBisnisUnitCreate';
import UsersBisnisUnitEdit from '@/pages/UsersBisnisUnitEdit';
import AdminBuList from '@/components/AdminBuList';
import AdminBUFormCreate from '@/pages/AdminBUFormCreate';
import AdminBUFormEdit from '@/pages/AdminBUFormEdit';
import DataMaster from '@/pages/DataMaster';
import DataMasterCreate from '@/pages/DataMasterCreate';
import DataMasterEdit from '@/pages/DataMasterEdit';
import imApprove from '@/pages/ApprovalPage';
import ApprovalDialog from '@/components/ApprovalDialog';
import Home from '@/pages/Home.vue';
import Faq from '@/pages/Faq.vue';
import AdminFaq from '@/pages/SAdminFAQAdminList';
import UserFaq from '@/pages/SAdminFAQUserList';
import UploadUsers from '@/pages/UploadUsers.vue';
import Contact from '@/pages/Contact.vue';
import Setting from '@/pages/Setting.vue';
import ListAdminContact from '@/pages/ListAdminContact.vue';
import ListResend from '@/pages/ListResend.vue';
import Log from '@/pages/LogActivity.vue';
import MyCC from '@/pages/MyCC.vue';
import BlockedEmail from '@/pages/BlockedEmail.vue';
import BlockedEmailFormCreate from '@/pages/BlockedEmailFormCreate';
import BlockedEmailEdit from '@/pages/BlockedEmailEdit.vue';
import PVBankAccountList from '@/pages/PVBankAccountList.vue';
import PVBankAccountCreate from '@/pages/PVBankAccountCreate.vue';
import PVBankAccountEdit from '@/pages/PVBankAccountEdit.vue';
import COAList from '@/pages/COAList.vue';
import COACreate from '@/pages/COACreate.vue';
import COAEdit from '@/pages/COAEdit.vue';
import COABulkUpload from '@/pages/COABulkUpload.vue';
import Forbidden from '@/pages/Forbidden.vue';
import ApprovalBOD from '../pages/ApprovalBOD.vue';
import MyRequestPV from '@/pages/MyRequestPV.vue';
import MyApprovalPV from '@/pages/MyApprovalPV.vue';
import CreatePV from '@/pages/CreatePV.vue';
import EditPV from '@/pages/EditPV.vue';
const bodReportAccess = process.env.BOD_REPORT_ACCESS;
const bodReportAccessEmails = bodReportAccess.split(",")

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) return next();
    next('/');
}

const ifAuthenticated = (to, from, next) => {

    if (!store.getters.isAuthenticated) return next('/login');

    if (store.state.dataUsers.role == 'general') {
        if (store.getters.isAuthenticated && to.meta.isAdmin && to.meta.isSuperAdmin) router.go(-1)
        if (store.getters.isAuthenticated && !to.meta.isAdmin && !to.meta.isSuperAdmin) return next();
    }

    if (store.state.dataUsers.role == 'admin') {
        if (store.getters.isAuthenticated && to.meta.isAdmin || to.meta.length == null) return next();
    }

    if (store.state.dataUsers.is_super_admin || store.state.dataUsers.role == 'super_user') {
        return next();
    }

}

const ifAuthenticatedSavePrevRoute = (to, from, next) => {
    if (!store.getters.isAuthenticated) return next(`/login?redirect=${to.fullPath}`);
    
    // jika bukan special user, maka redirect ke homepage
    if (!bodReportAccessEmails || !bodReportAccessEmails.includes(store.state.dataUsers.user.email)) {
        return router.go(-1)
    }
    // jika special user, maka next
    else {
        return next()
    }
}

const ifPaymentVoucherUser = (to, from, next) => {
    if (!store.getters.isAuthenticated) return next('/login');
    
    // Check if user has payment voucher access in ANY BU
    // Always use bu[].is_payment_voucher, not user.is_payment_voucher
    const userData = store.state.dataUsers;
    const user = userData.user || userData;
    
    if (user && user.bu && Array.isArray(user.bu)) {
        const hasPVAccess = user.bu.some(bu => bu.is_payment_voucher === true);
        if (hasPVAccess) {
            return next();
        }
    }
    
    // Redirect to homepage if no access
    return next('/');
}

const dispatchLogout = (to, from, next) => {
    store.dispatch('logout').then(() => {
        next()
    })
}


const redirectToEngine = (to) => {
    let url = process.env.VUE_APP_API+`${to.path}`;
    return window.location.href = url;
    //next();
}

const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: [
        // {
        //     path: '/',
        //     name: 'MyRequest',
        //     component: MyRequest,
        //     beforeEnter: ifAuthenticated,
        // },
        {
            path: '/',
            name: 'Home',
            component: Home,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/listContactAdmin',
            name: 'ListAdminContact',
            component: ListAdminContact,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/signup',
            name: 'Signup',
            component: Signup,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/forgetpassword',
            name: 'ForgetPassword',
            component: ForgetPassword,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/passwordresetstep',
            name: 'PasswordResetStep',
            component: PasswordResetStep,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/resetpassword/:code',
            name: 'ResetPassword',
            component: ResetPassword,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/verification',
            name: 'VerificationCard',
            component: Verification,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Login,
            beforeEnter: dispatchLogout,
        },
        // {
        //     path: '/unregistered',
        //     name: 'Unregistered',
        //     component: Unregistered,
        //     beforeEnter: dispatchLogout,
        // },
        {
            path: '/my-request',
            name: 'My Request',
            component: MyRequest,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/my-approval',
            name: 'My Approval',
            component: IMRequest,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: [2] },
        },
        {
            path: '/my-approval/:token',
            name: 'My Approval Pending',
            component: IMApproval,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/pending-report',
            name: 'Report Pending Approval',
            component: ApprovalBOD,
            beforeEnter: ifAuthenticatedSavePrevRoute,
        },
        {
            path: '/im-approve/:id',
            name: 'IM Approval ',
            component: imApprove,
        },
        {
            path: '/im-budget',
            name: 'IM Budget',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: [1, 2, 4] }
        },
        {
            path: '/im-proposal-investasi',
            name: 'IM Proposal Investasi',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: [1, 2, 4] }
        },
        {
            path: '/create-memo',
            name: 'Memo',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            // meta: { allowedUserType: [1, 2, 4] }
        },
        {
            path: '/create-payment-memo',
            name: 'Memo-Payment',
            component: IMPayment,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/create-announcement-memo',
            name: 'Memo-Anouncement',
            component: IMAnouncement,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/internal-memo',
            name: 'Internal Memo',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: [1, 2, 4] }
        },
        {
            path: '/memo/edit/:id',
            name: 'Edit Memo',
            component: EditForm,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/memo-payment/edit/:id',
            name: 'Edit Memo Payment',
            component: EditFormPayment,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/memo-payment/edit/:id/copyIM',
            name: 'Edit Memo Payment',
            component: EditFormPayment,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/memo-announcement/edit/:id',
            name: 'Edit Memo Announcement',
            component: EditFormAnouncement,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/memo-announcement/edit/:id/copyIM',
            name: 'Edit Memo Announcement',
            component: EditFormAnouncement,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/im-non-budget/edit/:id',
            name: 'Edit IM General',
            component: EditForm,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/internal-memo/edit/:id',
            name: 'Edit Internal Memo',
            component: EditForm,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/page-approval/:im_no/:token',
            name: 'Approval Landing Page',
            component: Approval,
            beforeEnter: redirectToEngine,
        },
        {
            path: '/wa-register',
            name: 'Whatsapp Registration',
            component: RegWaNumber,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/whatsapp-number-registration/:token',
            name: 'Whatsapp Number Registration',
            component: RegWaNumberWithoutLogin,
        },
        {
            path: '/my-profile',
            name: 'My Profile',
            component: MyProfile,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/qr-scan',
            name: 'QrScan',
            component: QrScan,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/page-detail/:im_no',
            name: 'View Landing Page',
            component: ViewApproval,
        },
        {
            path: '/users',
            name: 'Users',
            component: Users,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/users/create',
            name: 'Users Create',
            component: UsersFormCreate,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/users/edit/:id',
            name: 'Users Edit',
            component: UsersFormEdit,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/users/detail/:id',
            name: 'Users Detail',
            component: UsersBisnisUnit,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/resend',
            name: 'Resend Page',
            component: ListResend,
            beforeEnter: ifAuthenticated,
            meta: { isAdmin: true }
        },
        {
            path: '/users/detail/:id/create',
            name: 'Users Bisnis Unit Create',
            component: UsersBisnisUnitCreate,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/users/detail/:id/edit/:bu_id',
            name: 'Users Bisnis Unit Update',
            component: UsersBisnisUnitEdit,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/users-general',
            name: 'Users General',
            component: AdminBuList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/users/admin/bu/create',
            name: 'Users Admin BU Create',
            component: AdminBUFormCreate,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/users/admin/bu/edit/:id/:user',
            name: 'Users Admin BU Edit',
            component: AdminBUFormEdit,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/data-bu',
            name: 'Data BU',
            component: DataMaster,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true },
        },
        {
            path: '/data-master/create',
            name: 'Data Master Create',
            component: DataMasterCreate,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true },
        },
        {
            path: '/data-master/edit/:id',
            name: 'Data Master Edit',
            component: DataMasterEdit,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true },
        },
        {
            path: '/approval-dialog',
            name: 'Approval Dialog',
            component: ApprovalDialog,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq,
            // beforeEnter: ifAuthenticated
        },
        {
            path: '/faq-admin',
            name: 'Faq',
            component: AdminFaq,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/faq-user',
            name: 'Faq',
            component: UserFaq,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/im-export',
            name: 'IMExport',
            component: IMExport,
            beforeEnter: ifAuthenticated
        },
        
        {
            path: '/upload-users',
            name: 'Upload Users',
            component: UploadUsers,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/cms-bank',
            name: 'CMSBank',
            component: CMSBank,
            meta: { isSuperAdmin: true }
        },
        {
            path: '/blocked-email',
            name: 'Blocked Email',
            component: BlockedEmail,
            meta: { isSuperAdmin: true }
        },
        {
            path: '/blocked-email/create',
            name: 'Blocked Email Create',
            component: BlockedEmailFormCreate,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/blocked-email/edit/:id',
            name: 'Blocked Email Edit',
            component: BlockedEmailEdit,
            beforeEnter: ifAuthenticated,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/setting',
            name: 'Setting',
            component: Setting,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/log',
            name: 'Log',
            component: Log,
            meta: { isSuperAdmin: true, isAdmin: true }
        },
        {
            path: '/my-cc',
            name: 'My CC',
            component: MyCC,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/pv-bank-accounts',
            name: 'PV Bank Account List',
            component: PVBankAccountList,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/pv-bank-accounts/create',
            name: 'PV Bank Account Create',
            component: PVBankAccountCreate,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/pv-bank-accounts/edit/:id',
            name: 'PV Bank Account Edit',
            component: PVBankAccountEdit,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/coa',
            name: 'COA List',
            component: COAList,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/coa/create',
            name: 'COA Create',
            component: COACreate,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/coa/edit/:id',
            name: 'COA Edit',
            component: COAEdit,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/coa/bulk-upload',
            name: 'COA Bulk Upload',
            component: COABulkUpload,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/forbidden',
            name: 'Forbidden',
            component: Forbidden,
        },
        {
            path: '/my-request-pv',
            name: 'My Request PV',
            component: MyRequestPV,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/my-approval-pv',
            name: 'My Approval PV',
            component: MyApprovalPV,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/create-pv',
            name: 'Create PV',
            component: CreatePV,
            beforeEnter: ifPaymentVoucherUser,
        },
        {
            path: '/pv/edit/:id',
            name: 'Edit PV',
            component: EditPV,
            beforeEnter: ifPaymentVoucherUser,
        },
    ],
});

export default router;
